import React, { useState } from "react";
import {
  useDispatch,
  useSelector,
} from "react-redux";
import lodash from "lodash";

import {
  getOptionLabel,
  getReferences,
  isOptionEqualToValue,
} from "api";
import AutocompleteInput from "shared/AutocompleteInput";
import { autocompletesInitialValues } from "store/initialState";

export function SalePointCategoryAutocomplete({
  value,
  updateValue,
  validated = false,
  name = "categoryId",
}) {
  const dispatch = useDispatch();
  const { categories, category, user} = useSelector(
    (store) => store
  );
  const [options, setOptions] = useState([]);
  const [stateValue, setStateValue] =
    useState(value);

  React.useEffect(() => {
    setStateValue((state) =>
      lodash.isEqual(value, state) ? state : value
    );
  }, [value]);

  function onChange(option) {
    setStateValue(option);
    if (typeof updateValue === "function")
      updateValue(option);
  }

  React.useEffect(() => {
    if (Array.isArray(categories)) {
      const result = validated
        ? []
        : [
            autocompletesInitialValues.salePointCategory,
          ];
      categories.forEach((c) => {
        if (
          Array.isArray(category[c.referenceId])
        ) {
          category[c.referenceId].forEach((e) => {
            e.groupName = c.value;
            result.push(e);
          });
        }
      });
      setOptions(result);
    }
  }, [validated, categories, category]);
  return (
    <AutocompleteInput
      value={stateValue}
      onChange={onChange}
      label="Категория ТТ"
      options={options}
      groupBy={(option) => option.groupName}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      fetchOptions={(searchText, callback) =>
        dispatch(
          getReferences(
            "Category",
            { searchText },
            callback
          )
        )
      }
      validated={validated}
      name={name}
      disabled={user?.role !== "Admin"}
    />
  );
}
